import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Pencil, Trash2, GripVertical } from 'lucide-react';
import type { SelectionCategoryConfig } from '@/types/firestore';

interface SelectionCategoryItemProps {
  category: SelectionCategoryConfig;
  onEdit: () => void;
  onDelete: () => void;
  showDragHandle?: boolean;
}

export function SelectionCategoryItem({
  category,
  onEdit,
  onDelete,
  showDragHandle = true,
}: SelectionCategoryItemProps) {
  const optionCount = category.options?.length || 0;

  return (
    <div className="flex items-center gap-2 p-2 rounded border bg-muted/30 hover:bg-muted/50 transition-colors group">
      {showDragHandle && (
        <GripVertical className="h-4 w-4 text-muted-foreground shrink-0 cursor-grab" />
      )}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium truncate">{category.label}</span>
          <Badge variant="outline" className="text-[10px] shrink-0">
            {optionCount} option{optionCount !== 1 ? 's' : ''}
          </Badge>
          {category.allowColor && (
            <Badge variant="secondary" className="text-[10px] shrink-0">
              Color
            </Badge>
          )}
        </div>
      </div>
      <div className="flex gap-1 shrink-0 opacity-0 group-hover:opacity-100 transition-opacity">
        <Button
          variant="ghost"
          size="icon"
          className="h-7 w-7"
          onClick={onEdit}
        >
          <Pencil className="h-3 w-3" />
        </Button>
        <Button
          variant="ghost"
          size="icon"
          className="h-7 w-7 text-destructive hover:text-destructive"
          onClick={onDelete}
        >
          <Trash2 className="h-3 w-3" />
        </Button>
      </div>
    </div>
  );
}
